import retime from './mutations/retime'
import smartKeys from './mutations/smartKeys'
import tracks from './mutations/tracks'
import timeline from './mutations/timeline'
import core from './mutations/core'

const mutations = {
  ...retime,
  ...smartKeys,
  ...tracks,
  ...timeline,
  ...core,
}

export default mutations
